
jQuery(document).ready(function($){
    $('#fp-add-to-cart .qtyplus').click(function(e){
        e.preventDefault();
        fieldName = $(this).attr('field');
        var currentVal = parseInt($('#fp-add-to-cart input[name='+fieldName+']').val());
        if (!isNaN(currentVal)) {
            $('#fp-add-to-cart input[name='+fieldName+']').val(currentVal + 1);
        } else {
            $('#fp-add-to-cart input[name='+fieldName+']').val(1);
        }
        recountPrice($('#fp-add-to-cart input[name='+fieldName+']'));
    });
    $("#fp-add-to-cart .qtyminus").click(function(e) {
        e.preventDefault();
        fieldName = $(this).attr('field');
        var currentVal = parseInt($('#fp-add-to-cart input[name='+fieldName+']').val());
        if (!isNaN(currentVal) && currentVal > 1) {
            $('#fp-add-to-cart input[name='+fieldName+']').val(currentVal - 1);
        } else {
            $('#fp-add-to-cart input[name='+fieldName+']').val(1);
        }
        recountPrice($('#fp-add-to-cart input[name='+fieldName+']'));
    });
    function recountPrice(elem) {
        $(".fp-add-to-cart__price").html(Math.trunc((elem.val() * $(".fp-add-to-cart__price").data('price'))));
    }
    $('.fp-add-to-cart__volume-select').change(function (e) {
        $(".fp-add-to-cart__product-id").val($(this).val());
        $(".fp-add-to-cart__price").data('price', $(this).find(':selected').data('price'));
        recountPrice($('#fp-add-to-cart input[name=quantity]'));
        $(this).val();
    });
    $('.fp-add-to-cart__submit').click(function(e){
        e.preventDefault();
        $.post('/cart/add.js', {
            quantity: $('#fp-add-to-cart input[name=quantity]').val(),
            id: $(".fp-add-to-cart__product-id").val()
        }).done(function (){
            setTimeout(function() {

                updateCartAJAX();
                $('body, .cart-sidebar').addClass('open');
    
                }, 1500);
        });
    });
    $(document).on('mouseover click', ".locations__location-title", function() {
        $(".locations__location").removeClass('active');
        $(".locations__location-images").removeClass('active');
        $(".locations__location-" + $(this).data('location')).addClass('active');
        $(".locations__location-images-" + $(this).data('location')).addClass('active');
        $(".locations__location-title").removeClass("active");
        $(this).addClass("active");
    });
    $(document).on('mouseover', ".cta__button", function() {
        $(this).closest('.cta__block').addClass("cta__block-white");
    });
    $(document).on('mouseout', ".cta__button", function() {
        $(this).closest('.cta__block').removeClass("cta__block-white");
    });
});